import { z } from "zod";
import type { ManualResult } from "./network/useSubmitManualResults";

export const diagnosticReportFormSchema = z.object({
  files: z.array(z.instanceof(File)).min(1, "Required."),
  reportReceivedDate: z.date(),
  reportStatus: z.string(),
});

export const manualResultFormSchema = z.object({
  resultsList: z
    .array(
      z
        .object({
          code: z.string(),
          resultValue: z.string().min(1, "A result value is required."),
          codeDisplay: z.string(),
        })
        .strict()
        .refine((_): _ is ManualResult => true),
    )
    .min(1, "At least one result is required."),
});
